<template>
  <div class="orderFormSelectContainer">
    <div class="forms">
      <div class="CategoryName" v-if="!isCategorySelected">
        <p>商品カテゴリ</p>
      </div>
      <div class="CategoryName">
        <p style="margin-top: 5px;">{{ form.name }}</p>
      </div>
      <!-- Category Selection -->
      <transition name="slide-left" mode="out-in">
        <div class="SelectTabletType">
          <ButtonGroup :variant="{ align: 'center' }">
            <!-- Parent Category Input -->
            <VisualButton
              text="商品カテゴリに戻る"
              v-if="isCategorySelected"
              @click="_onClickCategoryInput()"
              :variant="{
                type: isCategorySelected ? 'default' : 'disabled',
                focus: !isCategorySelected
              }"
            ></VisualButton>
          </ButtonGroup>
        </div>
      </transition>

      <!-- Category Selection -->
      <div class="CardContainer" v-if="!isCategorySelected">
        <el-card
          :body-style="{ padding: '0px' }"
          v-for="item in categories"
          :key="item.id"
          shadow="never"
          class="Card"
          :class="{ isSelected: item.id === form.id }"
        >
          <div @click="_onClickCategoryCard(item)" class="Card__Inner">
            <img :src="item.imageUrl" :alt="item.name" class="card__image" />
            <div>
              <span class="title">{{ item.name }}</span>
            </div>
          </div>
        </el-card>

        <!-- <el-card
          :body-style="{ padding: '0px' }"
          shadow="never"
          class="Card"
          :class="{ isSelected: isNoProductSelected }"
        >
          <div @click="_onCLickNoProduct()" class="Card__Inner">
            <img src="@/assets/product-card-spacer.png" class="card__image" />
            <div class="title-dummy"></div>
            <span class="title--textonly">商品選択なし</span>
          </div>
        </el-card> -->
      </div>

      <!-- Product Selection -->
      <div v-if="isCategorySelected">
        <OrderFormStep3 :selectedCategoryId="form.id" />
      </div>
    </div>

    <OrderFormFooter
      :message="
        isCategorySelected
          ? '商品を選択してください'
          : '商品カテゴリを選択してください'
      "
      :canClickGoBack="true"
      @onClickGoBack="onClickGoBack"
      :canClickGoForward="isValidInput"
      @onClickGoForward="onClickGoForward"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { produce } from "immer";
import ProductCategoryUsecase from "@/usecases/product.usecase";
// Data Handler
import EntityFactory from "@/entities/entity.factory";
import UsecaseFactory from "@/usecases/usecase.factory.js";
// Components
import OrderFormFooter from "@/components/OrderFormFooter";
import VisualButton from "@/components/VisualButton";
import ButtonGroup from "@/components/ButtonGroup";
import OrderFormStep3 from "@/components/OrderFormStep3.module";
import { apiErrorHandler } from "@/services/apiErrorHandler";

const orderOption = EntityFactory.create("orderOption");
const productUsecase = UsecaseFactory.create("product");
const PLACEHOLDER_PARENT_CATEGORY = "カテゴリー";

export default {
  components: {
    OrderFormFooter,
    VisualButton,
    ButtonGroup,
    OrderFormStep3,
  },
  async created () {
    try {
      const clientGroupId = this.clientGroupInput.id;
      const categories = await productUsecase.getCategories(clientGroupId);
      this.$store.commit("master/set", {
        key: "categories",
        value: categories,
      });
    } catch (err) {
      apiErrorHandler(this, err);
    }
  },
  async mounted () {
    if (this.category.category && this.$route.path === "/orders/create/step2") {
      this.parentCategoryName = this.category.category.name;
    } else if (this.$route.path === "/home") {
      this.form = {};
    }

    // update step
    this.$store.commit("orderForm/setCurrentStep", 1);
    this.path = this.$router.history.current.path;
  },
  data () {
    return {
      tabletTypeOptions: orderOption.tabletTypes,
      tabletNameCountOptions: orderOption.nameCounts,
      PLACEHOLDER_PARENT_CATEGORY: PLACEHOLDER_PARENT_CATEGORY,
      productCategoryUsecase: new ProductCategoryUsecase(),
      isNoProductSelected: false,
      productNameForm: {
        azukariProductName: "",
        azukariProductSize: "",
      },
      path: "",
    };
  },
  computed: {
    ...mapState({
      categories: state => state.master.categories,
      category: state => state.orderForm.categoryInput,
      clientGroupInput: state => state.orderForm.clientGroupInput,
    }),
    ...mapGetters({
      previousStep: "orderForm/previousStep",
      nextStep: "orderForm/nextStep",
    }),
    form: {
      get () {
        return this.$store.state.orderForm.categoryInput;
      },
      set (value) {
        this.$store.commit("orderForm/setCategoryInput", { ...value });
      },
    },
    productForm: {
      get () {
        return this.$store.state.orderForm.productInput;
      },
      set (value) {
        this.$store.commit("orderForm/setProductInput", { ...value });
      },
    },
    isCategorySelected () {
      return !!(this.form && this.form.id);
    },
    isValidInput () {
      return this._isValidInput();
    },
  },
  methods: {
    onClickGoForward () {
      this.$router.push(this.nextStep);
    },
    onClickGoBack () {
      this.$router.push(this.previousStep);
    },
    _onClickCategoryCard (category) {
      // update parent category choice
      this.parentCategoryName = category.name;
      // save seleciton data\
      this.form = category;
      this.isNoProductSelected = false;
    },
    _onCLickNoProduct () {
      this.parentCategoryName = "商品選択なし";
      this.isNoProductSelected = true;
    },
    _onClickCategoryInput () {
      // reset all the data and start from initial state
      this.initialize();
    },
    initialize () {
      this.form = null;
      this.productForm = null;
    },
    onClickCancel () {
      this.parentCategoryName = null;
      // save seleciton data\
      this.form = null;
      this.isNoProductSelected = true;
      this.productNameDialogVisible = false;
    },
    onClickOkAzukariProductModal () {
      this.productForm = produce(this.productForm, d => {
        d.azukariProductName = this.productNameForm.azukariProductName;
        d.azukariProductSize = this.productNameForm.azukariProductSize;
      });
      this.productNameDialogVisible = false;
    },
    _isValidInput () {
      if (this.isNoProductSelected) {
        return true;
      }
      if (
        this.form &&
        this.productForm &&
        this.productForm.product &&
        this.productForm.productVariation
      ) {
        return !!(
          this.form.id &&
          this.productForm.product.id &&
          this.productForm.productVariation.id
        );
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

$--gap: 25px;

.Card {
  cursor: pointer;
}
.card__image {
  width: 100%;
}
.title {
  font-weight: bold;
}
.CardContainer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: $--gap;
  margin: $--gap;
  text-align: center;
}
.SelectTabletType-CaretRightIcon {
  font-size: 30px;
}
.CategoryName {
  text-align: center;
  font-size: 200%;
  font-weight: bold;
  margin-bottom: -20px;
  margin-top: -10px;
}
.title-dummy {
  height: 24px;
  width: 100%;
}
.title--textonly {
  position: absolute;
  top: 0;
  left: 0;
  position: absolute;
  margin: auto;
  height: 24px;
  bottom: 0;
  right: 0;
  font-weight: bold;
}
.Card__Inner {
  position: relative;
  padding: 10px 0;
}

.isSelected {
  border: 2.5px solid $--color-primary;
}

.DialogActions {
  display: flex;
  border-top: 1px solid $--border-color-light;
  padding: 10px 0;
}

::v-deep .el-dialog__footer {
  padding: 0 !important;
}
</style>
